import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const CartPanel = ({ toggleCart }) => {
  const [cart, setCart] = useState({ items: [] });
  const navigate = useNavigate();

  const loadCart = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      const response = await api.get('cart', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCart(response.data);
    } catch (error) {
      console.error('Error loading cart:', error);
    }
  };

  // Al primo render + quando scatta 'cartUpdated'
  useEffect(() => {
    loadCart();
    const handleCartUpdate = () => loadCart();
    window.addEventListener('cartUpdated', handleCartUpdate);
    return () => window.removeEventListener('cartUpdated', handleCartUpdate);
  }, []);

  // Rimuove un singolo prodotto dal carrello
  const handleRemoveItem = async (productId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.delete('cart/remove', {
        headers: { Authorization: `Bearer ${token}` },
        data: { productId },
      });
      setCart(response.data.cart);
    } catch (error) {
      console.error('Error removing item from cart:', error);
    }
  };

  // Modifica la quantità (delta = +1 o -1)
  const handleQuantityChange = async (productId, delta) => {
    try {
      const currentItem = cart.items.find((item) => item.product._id === productId);
      if (!currentItem) return;
      const newQuantity = currentItem.quantity + delta;
      if (newQuantity < 1) return; // Nessun decremento sotto 1
      const token = localStorage.getItem('token');
      const response = await api.put(
        'cart/update',
        {
          productId,
          quantity: newQuantity,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCart(response.data.cart);
    } catch (error) {
      console.error('Error updating cart item:', error);
    }
  };

  // Calcolo totale
  const total = cart.items.reduce((acc, item) => acc + item.quantity * item.price, 0);

  // Funzione per il tasto "Paga"
  const handlePay = () => {
    // Chiudi il pannello e vai a /checkout
    toggleCart();
    navigate('/checkout');
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: '80px', // sotto la navbar
        right: '20px',
        width: '400px',
        maxHeight: '80vh',
        backgroundColor: '#fff',
        borderRadius: '10px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        zIndex: 1050,
        overflow: 'hidden',
      }}
    >
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
        <h5 className="mb-0">Carrello</h5>
        <button className="btn btn-sm btn-outline-secondary" onClick={toggleCart}>
          &times;
        </button>
      </div>

      {/* Lista prodotti */}
      <div style={{ maxHeight: '300px', overflowY: 'auto', padding: '1rem' }}>
        {cart.items.length === 0 ? (
          <p>Il tuo carrello è vuoto.</p>
        ) : (
          cart.items.map((item) => (
            <div key={item._id} className="d-flex align-items-center mb-3">
              <img
                src={
                  item.product?.images?.[0]
                    ? `https://api.iovendosiciliano.it/${item.product.images[0]}`
                    : 'https://via.placeholder.com/50'
                }
                alt={item.product?.name || 'Product'}
                className="me-3"
                style={{
                  width: '50px',
                  height: '50px',
                  objectFit: 'cover',
                  borderRadius: '5px',
                }}
              />
              <div className="flex-grow-1">
                <div>{item.product?.name}</div>
                <div className="d-flex align-items-center mt-1" style={{ gap: '0.5rem' }}>
                  {/* Freccia giù */}
                  <button
                    className="btn btn-sm btn-secondary"
                    onClick={() => handleQuantityChange(item.product._id, -1)}
                  >
                    &#9660;
                  </button>
                  <span>{item.quantity}</span>
                  {/* Freccia su */}
                  <button
                    className="btn btn-sm btn-secondary"
                    onClick={() => handleQuantityChange(item.product._id, +1)}
                  >
                    &#9650;
                  </button>
                </div>
              </div>
              <div className="text-end">
                <strong>€{(item.price * item.quantity).toFixed(2)}</strong>
                <br />
                <button
                  className="btn btn-sm btn-link text-danger p-0"
                  onClick={() => handleRemoveItem(item.product._id)}
                >
                  Rimuovi
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Totale + Paga */}
      <div className="p-3 border-top">
        <div className="d-flex justify-content-between mb-2">
          <span>Totale</span>
          <strong>€{total.toFixed(2)}</strong>
        </div>
        <button className="btn btn-success w-100" onClick={handlePay}>
          Paga
        </button>
      </div>
    </div>
  );
};

export default CartPanel;
